import { IFileViewerFile, IFileViewerFileWithId } from '../components/file-viewer/file-viewer.interface';
import { PhotoGalleryGroupDirective } from './photo-gallery-group.directive';
import { AfterContentInit, Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { getFileViewerType } from '../components/file-viewer/file-viewer.constants';
import { v4 } from 'uuid';

@Directive({
  selector: '[appPhotoGallery]',
  standalone: false
})
export class PhotoGalleryDirective implements AfterContentInit, OnDestroy {
  @Input('appPhotoGallery') file!: IFileViewerFile;

  private galleryFile?: IFileViewerFileWithId;

  constructor(
    private photoGalleryGroup: PhotoGalleryGroupDirective,
  ) { }

  ngAfterContentInit(): void {
    const type = getFileViewerType(this.file.mimeType);
    if (!this.file.url || !type) return;

    this.galleryFile = {
      ...this.file,
      id: v4(),
      type,
    };

    this.photoGalleryGroup.registerGalleryItem(this.galleryFile);
  }

  ngOnDestroy(): void {
    if (this.galleryFile) {
      this.photoGalleryGroup.unregisterGalleryItem(this.galleryFile);
    }
  }

  @HostListener('click')
  onClick(): void {
    if (this.photoGalleryGroup.params.clickMode === 'single' && this.galleryFile) {
      this.photoGalleryGroup.openModal(this.galleryFile);
    }
  }

  @HostListener('dblclick')
  onDblClick(): void {
    if (this.photoGalleryGroup.params.clickMode === 'double' && this.galleryFile) {
      this.photoGalleryGroup.openModal(this.galleryFile);
    }
  }
}
